import React, { useState, useEffect } from 'react';
import { authService, AuthState } from '../../services/auth.service';
import Navbar from '../../component/includes/navbar';
import Footer from '../../component/includes/footer';


function Profile() {
  const [userInfo, setUserInfo] = useState<{
    username: string | null;
    email: string | null;
  }>({
    username: null,
    email: null,
  });

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const authState: AuthState = authService.getAuthState();
    setIsAuthenticated(authState.isAuthenticated);

    if (authState.isAuthenticated) {
      const storageType = localStorage.getItem('storageType') === 'local' ? localStorage : sessionStorage;

      setUserInfo({
        username: storageType.getItem('username'),
        email: storageType.getItem('email'),
      });
    }
  }, []);

  const handleLogout = () => {
    authService.logout();
    window.location.href = '/login';
  };

  const getProfileImage = () => {
    const username = userInfo.username || "User";
    const firstLetter = username.charAt(0).toUpperCase();
    return `https://ui-avatars.com/api/?name=${firstLetter}&background=4A90E2&color=fff&size=120`;
  };

  if (!isAuthenticated) {
    return (
      <div className="flex flex-col min-h-screen items-center justify-center bg-gradient-to-r from-purple-500 via-pink-500 to-red-500">
        <p className="text-2xl font-bold text-white">Please log in to view your profile</p>
        <button 
          onClick={() => window.location.href = '/login'}
          className="mt-6 px-8 py-3 bg-white text-purple-600 font-semibold rounded-lg shadow-lg hover:bg-gray-100 transition duration-300"
        >
          Go to Login
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-gray-50 to-gray-200">
      <Navbar />
      <main className="flex-grow mt-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="bg-white rounded-lg shadow-md p-6 max-w-md mx-auto">
            <div className="flex flex-col items-center">
              <img
                src={getProfileImage()}
                alt="Profile"
                className="rounded-full w-24 h-24 mb-4 border-2 border-indigo-600 shadow-sm"
              />
              <h2 className="text-2xl font-semibold text-gray-800">{userInfo.username || 'User'}</h2>
              <p className="text-gray-600 mt-1">{userInfo.email}</p>
            </div>

            <div className="mt-8 text-center">
              <button 
                onClick={handleLogout}
                className="px-6 py-2 bg-red-600 text-white font-medium rounded-md shadow-md hover:bg-red-700 transition duration-300"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Profile;